import { render, staticRenderFns } from "./puDialog_component.vue?vue&type=template&id=9e4c5a4c&scoped=true&"
import script from "./puDialog_component.vue?vue&type=script&lang=js&"
export * from "./puDialog_component.vue?vue&type=script&lang=js&"
import style0 from "./puDialog_component.vue?vue&type=style&index=0&id=9e4c5a4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4c5a4c",
  null
  
)

export default component.exports